import { Link } from "react-router-dom";
import { hasRole } from "../../../components/Utils";
import { OvalLoader } from "../../../components/common/Loader";

// Card configuration with icons, colors, and data mapping
const cardConfig = [
  // Commented-out cards from original preserved as config entries (disabled)
  // { key: "countries", label: "Countries", icon: "bx-globe", color: "#1A4331", gradientBg: "linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)", dataKey: "countryCount", link: "/countries", permission: "countries-list", roles: [1] },
  // { key: "states", label: "States", icon: "bx-map", color: "#1A4331", gradientBg: "linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)", dataKey: "stateCount", link: "/states", permission: "states-list", roles: [1, 6] },
  // { key: "regions", label: "Regions", icon: "bx-map-pin", color: "#1A4331", gradientBg: "linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)", dataKey: "regionCount", link: "/regions", permission: "regions-list", roles: [1, 6, 7] },
  // { key: "chapters", label: "Chapters", icon: "bx-buildings", color: "#1A4331", gradientBg: "linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)", dataKey: "chapterCount", link: "/chapters", permission: "chapters-list", roles: [1, 6, 7, 2] },
  {
    key: "members",
    label: "Members",
    icon: "bx-group",
    color: "#fff",
    gradientBg: "linear-gradient(135deg, #1A4331 0%, #1A4331 100%)",
    dataKey: "usersCount",
    link: "/users",
    permission: "members-list",
    roles: null,
  },
  // { key: "countryAdmins", label: "Country Admins", icon: "bx-shield-quarter", color: "#1A4331", gradientBg: "linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)", dataKey: "countryAdminUsersCount", link: "/country-admin-users", permission: "country-admins-list", roles: [1] },
  // { key: "stateAdmins", label: "State Admins", icon: "bx-shield-quarter", color: "#1A4331", gradientBg: "linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)", dataKey: "stateAdminUsersCount", link: "/state-admin-users", permission: "state-admins-list", roles: [1, 6] },
  // { key: "regionAdmins", label: "Region Admins", icon: "bx-shield-quarter", color: "#1A4331", gradientBg: "linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)", dataKey: "regionAdminUsersCount", link: "/region-admin-users", permission: "region-admins-list", roles: [1, 6, 7] },
  // { key: "chapterAdmins", label: "Chapter Admins", icon: "bx-shield-quarter", color: "#1A4331", gradientBg: "linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)", dataKey: "chapterAdminUsersCount", link: "/chapter-admin-users", permission: "chapter-admins-list", roles: [1, 6, 7, 2] },
  {
    key: "fbms",
    label: "FBMs",
    icon: "bx-conversation",
    color: "#fff",
    gradientBg: "linear-gradient(135deg, #1A4331 0%, #1A4331 100%)",
    dataKey: "one2oneCount",
    link: "/one-to-one",
    permission: "dashboard-fbms-data-view",
    roles: null,
  },
  {
    key: "rfls",
    label: "RFLs",
    icon: "bx-share-alt",
    color: "#fff",
    gradientBg: "linear-gradient(135deg, #1A4331 0%, #1A4331 100%)",
    dataKey: "referralsCount",
    link: "/referrals",
    permission: "dashboard-rfls-data-view",
    roles: null,
  },
  {
    key: "tyns",
    label: "TYNs",
    icon: "bx-dollar-circle",
    color: "#fff",
    gradientBg: "linear-gradient(135deg, #1A4331 0%, #1A4331 100%)",
    dataKey: "tynsCount",
    link: "/tyfcbs",
    permission: "dashboard-tyns-data-view",
    roles: null,
  },
  {
    key: "generalVisitors",
    label: "General Visitors",
    icon: "bx-user-plus",
    color: "#fff",
    gradientBg: "linear-gradient(135deg, #1A4331 0%, #1A4331 100%)",
    dataKey: "generalVisitorsCount",
    link: "/visitors/general",
    permission: "dashboard-visitors-data-view",
    roles: null,
  },
  {
    key: "chiefGuest",
    label: "Chief Guest",
    icon: "bx-star",
    color: "#fff",
    gradientBg: "linear-gradient(135deg, #1A4331 0%, #1A4331 100%)",
    dataKey: "chiefGuestCount",
    link: "/visitors/chief-guest",
    permission: "dashboard-visitors-data-view",
    roles: null,
  },
  {
    key: "powerDate",
    label: "Power Date",
    icon: "bx-calendar-star",
    color: "#fff",
    gradientBg: "linear-gradient(135deg, #1A4331 0%, #1A4331 100%)",
    dataKey: "powerDateCount",
    link: "/visitors/power-date",
    permission: "dashboard-visitors-data-view",
    roles: null,
  },
  {
    key: "inductions",
    label: "Inductions",
    icon: "bx-user-check",
    color: "#fff",
    gradientBg: "linear-gradient(135deg, #1A4331 0%, #1A4331 100%)",
    dataKey: "inductionsCount",
    link: "/visitors/inductions",
    permission: "dashboard-visitors-data-view",
    roles: null,
  },
  // { key: "events", label: "Events", icon: "bx-calendar-event", color: "#1A4331", gradientBg: "linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)", dataKey: "eventsCount", link: "/events", permission: "events-list", roles: null },
];

const AnalyticsCards = ({ data, ovalLoading, hasPermission }) => {
  // Filter visible cards based on role and permission
  const visibleCards = cardConfig.filter((card) => {
    if (card.roles && !hasRole(card.roles)) return false;
    if (!hasPermission(card.permission)) return false;
    return true;
  });

  return (
    <div className="analytics-cards-grid">
      {visibleCards.map((card) => (
        <Link to={card.link} key={card.key} className="analytics-grid-card">
          <div className="analytics-grid-card-content">
            <div className="analytics-grid-card-data">
              <span className="analytics-grid-card-value">
                {ovalLoading ? (
                  <OvalLoader color={card.color} />
                ) : (
                  (data[card.dataKey] || 0).toLocaleString("en-IN")
                )}
              </span>
              <span className="analytics-grid-card-label">{card.label}</span>
            </div>
            <div
              className="analytics-grid-card-icon"
              style={{ background: card.gradientBg, color: card.color }}
            >
              <i className={`bx ${card.icon}`}></i>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
};

export default AnalyticsCards;
